// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"377":"play","485":"game","980":"leaderboard"}[chunkId] + "." + {"377":"787302c2","485":"49f36068","980":"d9a0a752"}[chunkId] + ".js";
};